import { CreateAlert } from '../../../shared/common-alerts/SKAlerts';

export const validateProduct = (payload, setAlert) => {
  if (!payload.SubCategoryId) {
    CreateAlert('Please select sub category!!', 'Warning', setAlert);
    return false;
  }
  if (!payload.ProductName?.trim()) {
    CreateAlert('Please enter product name!!', 'Warning', setAlert);
    return false;
  }
  if (!payload.Slug?.trim()) {
    CreateAlert('Please enter slug!!', 'Warning', setAlert);
    return false;
  }
  if (payload.Price === '' || payload.Price == null || Number.isNaN(Number(payload.Price))) {
    CreateAlert('Please enter valid price!!', 'Warning', setAlert);
    return false;
  }
  if (Number(payload.Price) < 0) {
    CreateAlert('Price cannot be negative!!', 'Warning', setAlert);
    return false;
  }
  if (payload.Rating !== '' && payload.Rating != null) {
    const rating = Number(payload.Rating);
    if (Number.isNaN(rating) || rating < 0 || rating > 5) {
      CreateAlert('Rating must be between 0 and 5!!', 'Warning', setAlert);
      return false;
    }
  }
  return true;
};
